import { LogoForProjects } from "./logoForProjects"

export const ProjectHeader = ({props, imgNumber}) => {
   return (
		<>
			<section className="px-[16px] md:px-[32px] lg:px-[192px] bg-[#C0D8D7] pb-[4rem] font-jakarta">
				<LogoForProjects />
				<div className="flex flex-col mt-[4rem] md:mt-[5rem] gap-[1rem] md:gap-[1rem]">
					<div className="flex gap-[0.5rem]">
						<div className="py-[0.5rem] px-[1rem] bg-[#E0FD60] text-[#002921] w-max rounded-full font-medium text-[16px] md:text-[17px]">
							Selected Work
						</div>
					</div>
					<h1 className="text-[3.5rem] md:text-[5rem] font-medium text-[#002921] tracking-tight leading-none">
						{props.title}
					</h1>
				</div>
			</section>
			<section className="px-[8px] md:px-[32px] lg:px-[192px] bg-[#C0D8D7] rounded-b-2xl pb-[10px] md:pb-[32px]">
				<img
					src={props.imgData[imgNumber]}
					alt=""
					className="rounded-2xl w-full object-cover"
				/>
			</section>
		</>
	);
}